import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faHashtag } from '@fortawesome/free-solid-svg-icons';

function Contacts() {
  return (
    <div>
        <div className='contacts_TOP'>
            Contacts
        </div>   
     <div className='inner_cont_BTM'>
        <div><FontAwesomeIcon icon={faPhone} /> 0793 550 890</div>
        <div><FontAwesomeIcon icon={faPhone} /> 0723 660 596</div>
        <div><FontAwesomeIcon icon={faEnvelope} /> hosteladventures@gmail.com</div>
        <div>
        Youtube: <a href='https://youtube.com/@hosteladventures1?si=NnWnrqem_dKwepfx'>Hostel Adventures</a></div>
    
        <div>
        Instagram: <a href='https://www.instagram.com/hos.teladventures?igsh=MWVtYzdsdmMyYTNjZw=='>@HOSTELADVE369</a>
        </div>
    
        <div>
        TikTok: <a href='https://vm.tiktok.com/ZMkaPdGVk/'>@hosteladventures</a>
        </div>
      </div> 
    </div>
  )
}

export default Contacts